import React, { useEffect, useRef, useState } from 'react'
import "./RequirementList.scss"
import { useContext,useMemo } from "react";


import DashboardHeader from '../../../components/dashboardheader/DashboardHeader'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import RequirementCard from './RequirementCard';
import usePaginatedList from '../../../components/paginationlist/usePaginationList';
import { AuthContext } from '../../../context/AuthContext';
import ContentLoader from '../../../components/spinner/ContentLoader';
import OverlayLoader from '../../../components/spinner/OverlayLoader';
import SearchList from '../../../components/searchlist/SearchList';
import { parseArrayField } from '../../../lib/allPurposeFunctions';

import CancelButton from '../../../components/buttons/cancelbutton/CancelButton';
import SaveRequirement from './SaveRequirement';
import { consumeObjectDraft } from '../../../lib/objectReturnStore';

function RequirementList() {
  const { toggleMenu } = useOutletContext();
  const { currentUser } = useContext(AuthContext);

  const location=useLocation();
  const pageLimit=10;

  const userReady = !!currentUser?.id;

  const navigate=useNavigate();
  const [searchTerm,setSearchTerm]=useState("");
  const storageKey = "requirementListPage"; // unique key for this page


  // let initialMode = 'default';

    // const restoredStateRef = useRef(null);



    // const restoredState = restoredStateRef.current;


    // for restoring previous state posts,filters,page
    
    // initialMode = !!restoredState?.requirementData?.length?'restored':'default';
  // const shouldRestore = !!restoredState?.requirementData?.length;

  //   const initialRequirementData = restoredState?.requirementData || [];
  //   const initialPage = restoredState?.page || 1;



    // const [mode, setMode] = useState(initialMode);


    // console.log("Requirement Initialmode:",initialMode);


  const {
    items: requirementData,
    setItems,
    // setInitialPage,
    loading,
    // setLoading,
    // setRestoredPage,
    reloading,
    // refresh,
    // isFetching,
    // serverTotal,
    // finishHydration,
    // hydrateTotalPages,

  } = usePaginatedList("/requirements", {
    limit: pageLimit,
    initialFilters:userReady ? { userid: currentUser.id } : {},
    // filters:{userid:currentUser?.id},
    scrollContainerSelector: ".requirementDataList", // use your existing scrollable container
    skipInitialFetch: false,
    storageKey: storageKey,

    // manualFetch:shouldRestore,
    // initialPage:initialPage,
  });

function restoreDraft() {

  const draft = consumeObjectDraft();
  if (!draft) return false;

  // console.log("posts ", posts);

  const returnedReqObject=draft.returnData;


  switch (draft.action) {

    case 'update':
      // console.log("now updating");

      setItems(prevReqs =>
        prevReqs.map(reqObject => {
          // console.log("Checking Requirement:", reqObject.id, "against draft:", returnedReqObject.id);
          if (String(reqObject.id) === String(returnedReqObject.id)) {
            // console.log("Updating Requirement:", reqObject, "with draft:", returnedReqObject);
            return { ...reqObject, ...returnedReqObject };
          }
          return reqObject;
        })
      );
      break;

    case 'add':
      // console.log("now adding");

      setItems(prevReqs => [returnedReqObject, ...prevReqs]);

      break;

    case 'delete':
      // console.log("now deleting");

      setItems(prevReqs =>
        prevPosts.filter(p => p.id !== returnedReqObject.id)
      );

      break;
  }

  // console.log("restored draft", draft);

  return true;
}



useEffect(() => {
  // to restore if coming back from savepost
  restoreDraft();
}, []);







  const handleNavigateRequirementView=(requirementItem)=>{
    //  e.preventDefault();
    //  alert("ss")
    // alert(Post.id)
    // e.stopPropagation(); // Prevent the click from propagating to the card
    // console.log(requirementItem);
    // console.log("for navigating to edit requirement ",requirementItem)
        navigate("/dashboard/saverequirement/", {
          state: {
            mode: 1,
            requirementObject: requirementItem,
            requirementId: requirementItem.id,
            userId: currentUser?.id,
          },
        });

    // persistAndNavigate('/dashboard/SaveRequirement/', {
    //   mode: 1,
    //   requirementObject: requirementItem,
    //   requirementId: requirementItem.id,
    //   userId: currentUser?.id,
    // });



  }


  const handleAddNewRequirement = async (e) => {
     e.preventDefault();
    //  alert("ss")
     try {
      console.log("for adding new requirement")
      navigate("/dashboard/saverequirement/", {
        state: {
          mode: 0,
          requirementObject: null,
          requirementId: 0,
          userId: currentUser?.id,
        },
      });
      
     } catch (error) {
      
     }
     

  }


    return (
    <div className="RequirementListPage">
        <div className="PageHeader">
            <DashboardHeader title="Requirements" toggleMenu={toggleMenu}></DashboardHeader>
        </div>

        <div className="RequirementList">

              <SearchList
                data={requirementData}
                dataFields={[
                  "requirementdetails",
                  // "clientcontactname",
                  "colonies",
                  "propertytypes",
                  "propertytags",
                  "transactiontypes",

                ]}
                // value={searchTerm}           // ✅ REQUIRED
                // onChange={setSearchTerm}     // ✅ REQUIRED
                serverConfig={{
                  url: "/requirements",
                  params: { userid: currentUser?.id},
                  limit:3,
                }}

                renderItem={(requirement) => (
                  <RequirementCard
                    key={requirement.id}
                    RequirementItem={requirement}
                    RequirementId={requirement.id}
                    userId={currentUser?.id}
                    onNavigateRequirementView={handleNavigateRequirementView}

                  />)}
              />

            
            <div className="requirementDataList">



                {loading ? (
                  <ContentLoader />
                ) : requirementData.length > 0 ? (
                  requirementData.map((requirement) => (
                    <RequirementCard
                            key={requirement.id}
                            RequirementItem={requirement}
                            RequirementId={requirement.id}
                            userId={currentUser?.id}
                            clientid={currentUser?.clientid}
                            onNavigateRequirementView={handleNavigateRequirementView}

                    />
              ))
                ):(
                  <p className="NoResults">No matching Requirements found</p>
                )

              }

            </div>



            {reloading && (
                <OverlayLoader
                  position="sticky"
                  bottom={0}
                  text="Loading more..."
                  background= "rgba(200, 200, 200, 0.7)"
                  height="150px"
                />

)}




        </div>
        <div className="buttonContainer">
          <button onClick={handleAddNewRequirement}>Add Requirement</button>
          <CancelButton></CancelButton>
        </div>


    </div>

  )
}

export default RequirementList
